/* Chahal Agri Farms — PIN code delivery-estimate checker on product pages.
 * -----------------------------------------------------------------
 * Shopper types a 6-digit PIN, gets "Delivered in 3–4 days".
 *
 * Runs entirely in the browser against the table below — no API call, no
 * server, no API key. That is deliberate: a courier API key cannot live in
 * theme JavaScript (anyone can read it in view-source), so a live lookup
 * would need an external proxy. Estimates keyed off the despatch pincode
 * cover the same customer question without that dependency.
 *
 * ETA_BY_PREFIX maps the first 2 digits of the destination PIN to a
 * [min, max] working-day range from our despatch hub, 244302 (Singhpur
 * Sani, Sambhal, UP). To retune, edit the numbers below — nothing else
 * depends on them. To replace with live Shiprocket data later, swap
 * lookupEta() for a fetch to a proxy; the rest of the widget is unchanged.
 */
(function () {
  'use strict';

  var ORIGIN_PIN = '244302';

  /* first 2 digits of destination PIN -> [min days, max days] */
  var ETA_BY_PREFIX = {
    /* Delhi NCR + Haryana */
    '11': [2, 3], '12': [2, 3], '13': [2, 3],
    /* Punjab + Chandigarh */
    '14': [3, 4], '15': [3, 4], '16': [3, 4],
    /* Himachal */
    '17': [3, 5],
    /* J&K + Ladakh */
    '18': [5, 8], '19': [5, 8],
    /* UP + Uttarakhand (24 = our own belt) */
    '20': [2, 3], '21': [2, 3], '22': [2, 3], '23': [2, 3], '24': [1, 3],
    '25': [2, 3], '26': [2, 4], '27': [3, 4], '28': [3, 4],
    /* Rajasthan */
    '30': [4, 5], '31': [4, 5], '32': [4, 5], '33': [4, 5], '34': [4, 6],
    /* Gujarat */
    '36': [4, 6], '37': [4, 6], '38': [4, 6], '39': [4, 6],
    /* Maharashtra + Goa */
    '40': [4, 5], '41': [4, 6], '42': [4, 6], '43': [4, 6], '44': [4, 6],
    /* Madhya Pradesh */
    '45': [4, 6], '46': [4, 6], '47': [4, 6], '48': [4, 6],
    /* Chhattisgarh */
    '49': [5, 7],
    /* Telangana + Andhra */
    '50': [5, 7], '51': [5, 7], '52': [5, 7], '53': [5, 7],
    /* Karnataka */
    '56': [5, 7], '57': [5, 7], '58': [5, 7], '59': [5, 7],
    /* Tamil Nadu + Puducherry */
    '60': [5, 7], '61': [5, 7], '62': [5, 7], '63': [5, 7], '64': [5, 7],
    /* Kerala */
    '67': [6, 8], '68': [6, 8], '69': [6, 8],
    /* West Bengal */
    '70': [5, 7], '71': [5, 7], '72': [5, 7], '73': [5, 7], '74': [6, 8],
    /* Odisha */
    '75': [5, 7], '76': [5, 7], '77': [6, 8],
    /* Assam + North East */
    '78': [7, 10], '79': [7, 10],
    /* Bihar + Jharkhand */
    '80': [4, 6], '81': [4, 6], '82': [4, 6], '83': [4, 6], '84': [4, 6],
    '85': [5, 7]
  };

  /* Islands: courier network is genuinely slow and patchy. */
  var SPECIAL = { '744': [8, 12], '682': [7, 10] };

  function lookupEta(pin) {
    var three = SPECIAL[pin.slice(0, 3)];
    if (three) return three;
    return ETA_BY_PREFIX[pin.slice(0, 2)] || null;
  }

  function daysLabel(r) {
    return r[0] === r[1]
      ? 'Delivered in ' + r[0] + ' day' + (r[0] === 1 ? '' : 's')
      : 'Delivered in ' + r[0] + '–' + r[1] + ' days';
  }

  var CSS =
    '.caf-pin{margin:14px 0 4px;padding:12px 14px;border:1px solid rgba(200,146,42,.35);' +
    'border-radius:8px;background:rgba(200,146,42,.07)}' +
    '.caf-pin__head{display:flex;align-items:center;gap:7px;font-size:12.5px;font-weight:700;' +
    'color:#1a3028;margin-bottom:8px;letter-spacing:.02em}' +
    '.caf-pin__row{display:flex;gap:8px;flex-wrap:wrap}' +
    '.caf-pin__input{flex:1 1 130px;min-width:0;padding:9px 12px;border:1px solid #d8cfbc;' +
    'border-radius:6px;font-size:14px;color:#1a3028;background:#fff;font-family:inherit}' +
    '.caf-pin__input:focus{outline:none;border-color:#c8922a}' +
    '.caf-pin__btn{padding:9px 18px;border:0;border-radius:6px;background:#1a3028;color:#fff;' +
    'font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;letter-spacing:.03em}' +
    '.caf-pin__btn:hover{background:#2f7d46}' +
    '.caf-pin__out{margin-top:9px;font-size:13px;line-height:1.5;display:none}' +
    '.caf-pin__out.is-on{display:block}' +
    '.caf-pin__ok{color:#2f7d46;font-weight:700}' +
    '.caf-pin__sub{color:#5a4f42;font-size:11.5px;display:block;margin-top:2px}' +
    '.caf-pin__err{color:#a33; font-weight:600}';

  function injectCss() {
    if (document.getElementById('caf-pin-css')) return;
    var s = document.createElement('style');
    s.id = 'caf-pin-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function build() {
    var box = document.createElement('div');
    box.className = 'caf-pin';
    box.innerHTML =
      '<div class="caf-pin__head">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c8922a" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>' +
        '<circle cx="12" cy="10" r="3"/></svg>' +
        'Check delivery time' +
      '</div>' +
      '<div class="caf-pin__row">' +
        '<input class="caf-pin__input" type="text" inputmode="numeric" maxlength="6" ' +
        'placeholder="Enter 6-digit PIN code" aria-label="Delivery PIN code">' +
        '<button type="button" class="caf-pin__btn">CHECK</button>' +
      '</div>' +
      '<div class="caf-pin__out" role="status" aria-live="polite"></div>';

    var input = box.querySelector('.caf-pin__input');
    var btn = box.querySelector('.caf-pin__btn');
    var out = box.querySelector('.caf-pin__out');

    function show(html) {
      out.innerHTML = html;
      out.classList.add('is-on');
    }

    function check() {
      var pin = (input.value || '').replace(/\D/g, '');
      if (pin.length !== 6) {
        show('<span class="caf-pin__err">Please enter a valid 6-digit PIN code.</span>');
        return;
      }
      var eta = lookupEta(pin);
      if (!eta) {
        show('<span class="caf-pin__err">We could not estimate for this PIN.</span>' +
             '<span class="caf-pin__sub">Please WhatsApp us and we’ll confirm.</span>');
        return;
      }
      show('<span class="caf-pin__ok">✓ ' + daysLabel(eta) + '</span>' +
           '<span class="caf-pin__sub">Estimated working days from despatch (' + ORIGIN_PIN +
           '). Cash on Delivery available.</span>');
    }

    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
    });

    return box;
  }

  /* Place it just under the buy buttons, above the product description. */
  function mount() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.caf-pin')) return;
    var anchor =
      document.querySelector('.product-form__buttons') ||
      document.querySelector('product-form') ||
      document.querySelector('.shopify-payment-button') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!anchor) return;
    injectCss();
    anchor.insertAdjacentElement('afterend', build());
  }

  function boot() {
    mount();
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(mount, 200);
    });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
